export default __webpack_public_path__ + "static/char-v-59-zh-Hant-609a3e4a1679f5963ef7c84a1c992ee8.mp4";